import {
    CLINIC_SUBSCRIPTION_PATH,
    isBillingActivationPending,
    resolveMarketplacePath,
} from "@/domains/multi/clinicMemberPaths";
import { resolveTeamChatActive } from "@/domains/shared/services/secretaryClinicalPaths";
import { useAuth } from "@/domains/shared/hooks/useAuth";
import { Roles } from "@/domains/shared/models/roles";
import { Navigate, Outlet } from "react-router";

export default function TeamChatRouteGuard() {
    const { user } = useAuth();

    if (user?.role !== Roles.Therapist) {
        return <Outlet />;
    }

    if (!resolveTeamChatActive(user)) {
        if (isBillingActivationPending(user)) {
            return <Navigate to={CLINIC_SUBSCRIPTION_PATH} replace />;
        }

        return <Navigate to={resolveMarketplacePath(user, "secretary")} replace />;
    }

    return <Outlet />;
}
